import type { AisleCategory, ShoppingLine, Store } from './types.js';

/**
 * Real walking order per store. The point of the whole store-picker feature:
 * Aldi drops you in fruit and veg, Lidl in the bakery, and Tesco runs meat and
 * fish before dairy. Following the wrong order means walking the shop twice.
 */
export const AISLE_ORDER: Record<Store, readonly AisleCategory[]> = {
  aldi: ['produce', 'bakery', 'dairy_chilled', 'meat_fish', 'ambient', 'frozen', 'drinks', 'household'],
  lidl: ['bakery', 'produce', 'dairy_chilled', 'meat_fish', 'ambient', 'frozen', 'drinks', 'household'],
  tesco: ['produce', 'bakery', 'meat_fish', 'dairy_chilled', 'ambient', 'frozen', 'drinks', 'household'],
};

export const AISLE_LABELS: Record<AisleCategory, string> = {
  produce: 'Fruit & veg',
  bakery: 'Bakery',
  dairy_chilled: 'Dairy & chilled',
  meat_fish: 'Meat & fish',
  ambient: 'Tins, dry & cupboard',
  frozen: 'Frozen',
  drinks: 'Drinks',
  household: 'Household',
};

export function aisleRank(store: Store, aisle: AisleCategory): number {
  const rank = AISLE_ORDER[store].indexOf(aisle);
  if (rank === -1) throw new Error(`Aisle "${aisle}" is missing from the ${store} layout`);
  return rank;
}

/** Stable sort into the store's walking order. Never mutates the input. */
export function sortByAisle(lines: ShoppingLine[], store: Store): ShoppingLine[] {
  return [...lines].sort((a, b) => aisleRank(store, a.aisle) - aisleRank(store, b.aisle));
}
